import { TextField as TextFieldLib } from "@mui/material";

import styled from "styled-components";

import { BASE_STYLE, VARIANT_STYLE } from "./constants";
import { SearchTextFieldVariant } from "./types";


export const TextField = styled(TextFieldLib)<{ styleVariant: SearchTextFieldVariant }>`
  ${BASE_STYLE}
  ${({ styleVariant }) => VARIANT_STYLE[styleVariant]}
`;
